/**
 * External Dependencies
 */
import 'jquery';

$(() => {
  // console.log('Hello world');
});
